import { QueryHookOptions, useQuery } from "@apollo/client";
import { graphql } from "~/gql";
import { FindOrganisationalUnitsQuery } from "~/gql/graphql";

export const ORGANISATIONAL_UNITS_QUERY = graphql(/* GraphQL */ `
  query FindOrganisationalUnits {
    organisationalUnits {
      id
      externalReference
      name
      order
      gpmDangerThreshold
      gpmWarningThreshold
      parent {
        id
        externalReference
        name
        order
        gpmDangerThreshold
        gpmWarningThreshold
      }
      children {
        id
        externalReference
        name
        order
        gpmDangerThreshold
        gpmWarningThreshold
      }
    }
  }
`);

export function useOrganisationalUnitsQuery(
  options?: QueryHookOptions<FindOrganisationalUnitsQuery>
) {
  return useQuery<FindOrganisationalUnitsQuery>(ORGANISATIONAL_UNITS_QUERY, options);
}
